// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__nKTGI","pageButton":"Pagination_pageButton__JKb0f","active":"Pagination_active__wmSkG","ellipsis":"Pagination_ellipsis__s5TIj"};